import React, { useState } from "react";

import {
  AUDITOR_TYPE_LABELS,
  AuditType,
  AuditorType,
} from "../../../api/audits";
import ConductedByModal from "./ConductedByModal";

interface ConductedByCellProps {
  auditType?: AuditType;
  auditorType?: AuditorType;
  auditorName?: string | null;
  onChange: (value?: {
    auditor_type: AuditorType;
    auditor_name?: string | null;
  }) => void;
}

const ConductedByCell: React.FC<ConductedByCellProps> = ({
  auditType,
  auditorType,
  auditorName,
  onChange,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleClick = () => {
    if (!auditType) return;
    setIsModalOpen(true);
  };

  return (
    <>
      {!auditorType ? (
        <button
          type="button"
          disabled={!auditType}
          onClick={handleClick}
          className={`py-1 text-sm font-normal text-[#0A0A0A]/60 focus:outline-none ${
            auditType
              ? "cursor-pointer"
              : "cursor-not-allowed opacity-50"
          }`}
        >
          Add
        </button>
      ) : (
        <button
          type="button"
          onClick={handleClick}
          className="flex w-full max-w-full flex-col items-start gap-2 text-left"
        >
          <span className="flex w-full max-w-full flex-col gap-0.5 font-[Inter]">
            <span className="text-[12px] font-normal leading-4 text-[#737373]">
              Auditor Type
            </span>

            <span className="break-words text-[12px] font-normal leading-4 text-[#0A0A0A]">
              {AUDITOR_TYPE_LABELS[auditorType]}
            </span>
          </span>

          <span className="flex w-full max-w-full flex-col gap-0.5 font-[Inter]">
            <span className="text-[12px] font-normal leading-4 text-[#737373]">
              Name
            </span>

            <span className="break-words text-[12px] font-normal leading-4 text-[#0A0A0A]">
              {auditorName?.trim() || "--"}
            </span>
          </span>
        </button>
      )}

      {isModalOpen && auditType && (
        <ConductedByModal
          auditType={auditType}
          auditorType={auditorType}
          auditorName={auditorName}
          onChange={(updatedValue) => {
            onChange(updatedValue);
            setIsModalOpen(false);
          }}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ConductedByCell;
